import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

// Pure DOM-measurement helpers shared by the checkout basket sticky logic and
// utility.ts's header scroll behavior. They live in their own module -- free of
// any top-level side effects -- so importers (e.g. the React Checkout entry)
// don't pull in utility.ts's module-load DOM mutations. On a full-document React
// page those mutations must be deferred until after hydration (see index.tsx and
// utility.ts); a static import of utility.ts anywhere eager would run them too
// early and trip hydration mismatches.

// Get an element's computed style property as a number.
const getComputedStyles = (el: string, prop: string): number => {
    const window = getWindow();
    const document = getDocument();
    if (!window || !document) {
        return 0;
    }
    const element = document.querySelector(el);
    if (element) {
        const compStyles = window.getComputedStyle(element);
        const computedValue = compStyles.getPropertyValue(prop);
        return parseFloat(computedValue);
    }
    return 0;
};

// Calculate the basket's sticky height start position (header height + the
// basket wrapper's top margin).
export const getNavHeight = (): number => {
    const document = getDocument();
    if (!document) {
        return 0;
    }
    const header = document.querySelector<HTMLElement>("header");
    if (header) {
        const style = header.offsetHeight;
        return style + getComputedStyles(".basket-wrapper", "margin-top");
    }
    return 0;
};
